import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/auth/auth-store';
import { SplashLoader } from './SplashLoader';

export function RequireAuth({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const loc = useLocation();

  if (auth.status === 'loading') return <SplashLoader />;
  if (auth.status === 'anon')
    return (
      <Navigate to="/login" state={{ from: loc.pathname + loc.search }} replace />
    );
  return <>{children}</>;
}
